// ─── WEAPON DATA ────────────────────────────────────────────────────────────
export const WEAPON_TYPES = [
  { id: "small_melee", name: "Small Melee", stat: "Speed", skill: "Small Weapons" },
  { id: "large_melee", name: "Large Melee", stat: "Might", skill: "Large Weapons" },
  { id: "two_handed_large", name: "2-Handed Large", stat: "Might", skill: "Large Weapons" },
  { id: "ranged", name: "Ranged (Bow)", stat: "Speed", skill: "Ranged" },
];

export const WEAPON_QUALITIES = {
  small_melee: [
    { id: "simple", name: "Simple", damage: "1D6", statMin: 0 },
    { id: "standard", name: "Standard", damage: "2D4", statMin: 10 },
    { id: "great", name: "Great", damage: "2D6", statMin: 20 },
    { id: "master", name: "Master", damage: "3D6", statMin: 30 },
  ],
  large_melee: [
    { id: "simple", name: "Simple", damage: "1D8", statMin: 0 },
    { id: "standard", name: "Standard", damage: "1D10", statMin: 10 },
    { id: "great", name: "Great", damage: "2D8", statMin: 20 },
    { id: "master", name: "Master", damage: "2D10", statMin: 30 },
  ],
  two_handed_large: [
    { id: "simple", name: "Simple", damage: "1D10", statMin: 10 },
    { id: "standard", name: "Standard", damage: "1D12", statMin: 20 },
    { id: "great", name: "Great", damage: "2D10", statMin: 30 },
    { id: "master", name: "Master", damage: "2D12", statMin: 40 },
  ],
  ranged: [
    { id: "simple", name: "Simple", damage: "1D10+2", statMin: 0 },
    { id: "standard", name: "Standard", damage: "2D6+3", statMin: 10 },
    { id: "great", name: "Great", damage: "2D8+4", statMin: 20 },
    { id: "master", name: "Master", damage: "3D8+6", statMin: 30 },
  ],
};

export const WEAPON_ABILITIES = [
  { id: "none", name: "None", desc: "" },
  { id: "cleave", name: "Cleave", desc: "When an enemy is killed, an enemy directly adjacent may be hit for half damage." },
  { id: "heavy", name: "Heavy", desc: "Add character's associated Stat Modifier in flat damage." },
  { id: "sharp", name: "Sharp", desc: "Deals Piercing damage." },
  { id: "reach", name: "Reach", desc: "Weapon has an added Step of effective range." },
  { id: "swift", name: "Swift", desc: "Weapon gains an additional +1 to hit." },
];

export const RANGED_SUBTYPES = [
  { id: "shortbow", name: "Shortbow", ability: "swift" },
  { id: "longbow", name: "Longbow", ability: "heavy" },
  { id: "crossbow", name: "Crossbow", ability: "sharp" },
];
